import { Component } from '@angular/core'

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    standalone: false,
})
export class MaintenanceComponent {}
